export default __webpack_public_path__ + "static/media/loader.d1744388.svg";